import React from 'react';

interface Props {
  className?: string;
}

const Barn: React.FC<Props> = ({ className = '' }: Props) => (
  <svg
    className={className}
    fill="none"
    height="14"
    viewBox="0 0 20 21"
    width="14"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="Ranch Land/Dark">
      <path
        d="M10 1.75C9.91931 1.75052 9.83921 1.76436 9.76262 1.79104C9.76212 1.79103 9.76162 1.79103 9.76112 1.79104L9.75511 1.79261C9.73631 1.79922 9.71777 1.80659 9.69952 1.81471L3.64333 4.20422H3.64032C3.52711 4.23727 3.42261 4.29714 3.33484 4.37921C3.24708 4.46129 3.17838 4.5634 3.13401 4.6777L0.133714 10.1827L0.0991587 10.2459C0.0347638 10.3658 0.000630551 10.5011 0 10.6388C0 10.8532 0.0810437 11.0587 0.225302 11.2102C0.369561 11.3618 0.565218 11.4469 0.769231 11.4469H1.53846V19.5277H4.61538C4.7629 19.5278 4.90736 19.4835 5.03155 19.3999L10 16.0444L14.9684 19.3999C15.0926 19.4835 15.2371 19.5278 15.3846 19.5277C15.3921 19.5278 15.3996 19.5278 15.4072 19.5277H18.4615V11.4469H19.2308C19.4348 11.4469 19.6304 11.3618 19.7747 11.2102C19.919 11.0587 20 10.8532 20 10.6388C19.9994 10.5011 19.9652 10.3658 19.9008 10.2459C19.8915 10.2276 19.8815 10.2097 19.8708 10.1922L16.8645 4.67454C16.8199 4.561 16.7513 4.45963 16.6638 4.37813C16.5763 4.29664 16.4723 4.23716 16.3597 4.20422L10.311 1.81944C10.2874 1.80872 10.2634 1.79923 10.2389 1.79104C10.1618 1.7642 10.0812 1.75035 10 1.75ZM8.46154 5.79038H11.5385V8.21461H8.46154V5.79038ZM6.03816 11.4469H13.9618L10 14.1221L6.03816 11.4469ZM4.61538 12.4081L8.57722 15.0833L4.61538 17.7584V12.4081ZM15.3846 12.4081V17.7584L11.4228 15.0833L15.3846 12.4081Z"
        fill="currentColor"
        id="Vector"
      />
    </g>
  </svg>
);

export default Barn;
